import { ApiBaseUrls } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export async function postRequestForCoverageRefresh(orderId: string) {
  const url = `${ApiBaseUrls.EV_BV_SERVICE}coverage/check-coverage-for-medical-pa-order`;
  const requestBody = { order_id: orderId };

  try {
    const bearerToken = await getBearerToken();
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Request failed with status ${response.status}: ${errorText}`,
      );
    }
    return response;
  } catch (error) {
    logError(error as Error, "Error while refreshing coverage");
    throw error;
  }
}
